import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { debounce } from 'lodash';
import { AuthorService } from 'src/app/api/blog/author.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-author',
  templateUrl: './search-author.component.html',
  styleUrls: ['./search-author.component.css']
})
export class SearchAuthorComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedEmployeeEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private authorService: AuthorService) {
  }

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.authorService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.name} ${item.fullname} ${item.document}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearch(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedEmployeeEvent.emit(item);
    this.data = [];
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}
